<template>
    <div class="sidebar__content">
        <h3 class="h5">Is er nog een plekje voor jou?</h3>

        <select-field v-model="selectedDate">
            <option
                v-for="(event, index) in product.events"
                :key="index"
                :value="index">
                {{ event.date | dateformat("D MMMM YYYY") }}
            </option>
        </select-field>

        <hr >

        <ul class="sidebar__specs">
            <li>
                <div class="label-text">
                    tijd
                </div>

                <div>{{ currentActivity.start_time | dateformat("HH:mm") }} - {{ currentActivity.end_time | dateformat("HH:mm") }} uur</div>
            </li>
            <li>
                <div class="label-text">
                    Locatie activiteit
                </div>

                <div class="sidebar__logo-text">
                    <div>
                        {{ product.location.name }} - {{ product.location.street }} {{ product.location.house_number }},
                        {{ product.location.postal_code }} {{ product.location.city }}
                    </div>

                    <figure>
                        <img
                            v-if="product.location.images.thumbnail"
                            :src="product.location.images.thumbnail"
                            :alt="product.location.name">
                    </figure>
                </div>
            </li>
            <li v-if="currentActivity.available_places > 0">
                <div class="label-text">
                    Beschikbaarheid
                </div>

                <div>Nog {{ currentActivity.available_places }} plekken beschikbaar!</div>
            </li>
            <li v-if="currentActivity.register_before">
                <div class="label-text">
                    Uiterste inschrijfdatum
                </div>

                <div>{{ currentActivity.register_before | dateformat("D MMMM YYYY") }}</div>
            </li>
            <li v-if="currentActivity.trainer">
                <div class="label-text">
                    Trainer
                </div>

                <div>{{ currentActivity.trainer }}</div>
            </li>
        </ul>

        <div class="sidebar__btn-holder">
            <router-link
                :to="{ name: 'redeem_voucher', params: { activity_id: $route.params.activity_id, campaign: campaign }, query: { id: currentActivity.id } }"
                class="btn">
                Code verzilveren
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            selectedDate: '0',
        }
    },
    computed: {
        campaign() {
            return this.$route.params.campaign;
        },
        currentActivity() {
            if(this.product.events.length === 0) {
                return null;
            } else {
                return this.product.events[this.selectedDate];
            }
        },
    },
    created() {
        Object.entries(this.product.events).forEach((item) => {
            if(item[1].date === this.$route.query.datum) {
                this.selectedDate = item[0];
            }
        });
    }
};
</script>
